import * as yup from 'yup';
yup.addMethod(yup.number, 'toPositive', function append() {
    return this.transform((value) => value < 0 ? 0.5 : value);
});
export const reportDataSchema = yup.object().camelCase().shape({
    id: yup.string().required().ensure(),
    patientId: yup.string().required().ensure(),
    reportId: yup.string().required().ensure(),
    reportTimestamp: yup.date().required(),
    averageGlucose: yup.number().defined(),
    tirVeryLow: yup.number().toPositive().defined(),
    tirLow: yup.number().toPositive().defined(),
    tirInRange: yup.number().toPositive().defined(),
    tirHigh: yup.number().toPositive().defined(),
    tirVeryHigh: yup.number().toPositive().defined(),
    cgmDays: yup.number().defined(),
    calibPerDay: yup.number().defined(),
    standardDeviation: yup.number().defined(),
    gmi: yup.number().nullable(),
    hypoEventsDay: yup.number().defined(),
    hypoEventsNight: yup.number().defined(),
    hyperEventsDay: yup.number().defined(),
    hyperEventsNight: yup.number().defined(),
    maxHigh: yup.number().defined(),
    maxLow: yup.number().defined(),
});
export const reportSchema = yup
    .object()
    .camelCase()
    .shape({
    id: yup.string().required(),
    patientId: yup.string().required(),
    path: yup.string(),
    reviewed: yup.boolean().defined(),
    reviewedAt: yup.date().nullable().default(null),
    offline: yup.boolean().defined(),
    inOffice: yup.boolean().defined(),
    timeInReview: yup.number().defined(),
    glucoseSensorReview: yup.string().ensure(),
    planOfAction: yup.string().ensure(),
    cgmUrl: yup.string().ensure(),
    reportData: reportDataSchema.nullable().default(null),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
});
